import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ClockIcon } from '@heroicons/react/24/outline';
import { useRouteLoaderData } from '@remix-run/react';

import type { loader as communityLoader } from '~/routes/community';

export const PostHistoryNotice: FC = () => {
  const { t } = useTranslation();
  const layoutData = useRouteLoaderData<typeof communityLoader>('routes/community');
  const days = layoutData?.community?.post_history_days;

  if (!days) return null;

  return (
    <p className="flex w-full items-start gap-2 rounded-xl bg-black/5 px-3 py-3 text-sm text-black/70">
      <ClockIcon className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <span>{t('community.feed.history_limit_notice', { days })}</span>
    </p>
  );
};
